import type { Application, Company } from '../store/projectStore';

export function filterTargetsForTenant({
  targets,
  tenantId,
}: {
  targets: Application[];
  tenantId: string | null | undefined;
}): Application[] {
  if (!tenantId) {
    return [];
  }

  return targets.filter(
    (target) => target.tenantId == null || target.tenantId === tenantId,
  );
}

export function filterCompaniesForTenant({
  companies,
  tenantId,
  restrictToCurrentTenant,
}: {
  companies: Company[];
  tenantId: string | null | undefined;
  restrictToCurrentTenant: boolean;
}): Company[] {
  if (!restrictToCurrentTenant) {
    return companies;
  }

  if (!tenantId) {
    return [];
  }

  return companies.filter((company) => company.tenantId === tenantId);
}
